import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=81a93f88&scoped=true&"
import script from "./AdminSection.vue?vue&type=script&lang=js&"
export * from "./AdminSection.vue?vue&type=script&lang=js&"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=81a93f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a93f88",
  null
  
)

export default component.exports